<template>
  <section class="calendar-wrapper" v-show="showCalendar">
    <!--<popup :value="showCalendar" @input="updateShow">-->
    <div class="space" @click.stop.prevent="$emit('update:showCalendar', false)"></div>
    <InlineCalendar
      class="calendar"
      :value="value"
      @input="syncValue"
      @on-change="onSelect"
      title="Calendar"
      :disable-past="true"
      :start-date="startDate"
      :weeksList="['周日', '周一', '周二', '周三', '周四', '周五', '周六']"
      :renderOnValueChange="true"
    ></InlineCalendar>
    <!--</popup>-->
  </section>
</template>

<script>
import { InlineCalendar } from '@lx-frontend/cvux'
export default {
  name: 'CustomCalendar',
  props: {
    showCalendar: {
      default: false,
      type: Boolean
    },
    value: {
      default: '',
      type: String
    },
    startDate: {
      type: String
    }
  },
  components: { InlineCalendar },
  methods: {
    onSelect() {
      this.$emit('update:showCalendar', false)
    },
    syncValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/base/fn";

  .calendar-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background-color: rgba(0, 0, 0, .5);

    .space {
      width: 100%;
      height: 780/@w2;
      opacity: 0;
    }

    .calendar {
      position: absolute;
      bottom: 0;
      z-index: 1;

      &::after, &::before {
        display: none;
      }

      th {
        text-align: center;
        font-weight: bold;
      }
    }
  }
</style>
